import { render, staticRenderFns } from "./CostImporterAdministrator.vue?vue&type=template&id=22eab567&scoped=true&"
import script from "./CostImporterAdministrator.vue?vue&type=script&lang=js&"
export * from "./CostImporterAdministrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eab567",
  null
  
)

export default component.exports